__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@ciam-admin-ui/host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vk-tech-solar/config", "0.83.0", () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(197), __webpack_require__.e(512)]).then(() => (() => (__webpack_require__(4512))))));
			register("@vk-tech-solar/core", "0.83.0", () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(167)]).then(() => (() => (__webpack_require__(3167))))));
			register("@vk-tech-solar/dev-tools-utils", "0.83.0", () => (Promise.all([__webpack_require__.e(694), __webpack_require__.e(197), __webpack_require__.e(85), __webpack_require__.e(555)]).then(() => (() => (__webpack_require__(4071))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(250).then(() => (() => (__webpack_require__(5250))))));
			register("mobx", "6.13.6", () => (__webpack_require__.e(794).then(() => (() => (__webpack_require__(3794))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};